export function CTA() {
  return `
    <section class="section text-center cta-section" >
      <div class="container" data-aos="fade-up">

        <h2 class="mb-3">Butuh Jasa Digital?</h2>
        <p class="text-secondary mb-4">
          Konsultasikan kebutuhan Anda sekarang, GRATIS tanpa biaya!
        </p>

        <a href="https://wa.me/6283872687465?text=Halo%20saya%20ingin%20konsultasi%20jasa%20Hunter%20Cuan" target="_blank" class="btn btn-danger btn-lg px-5">
          <i class="bi bi-whatsapp me-2"></i>
          Chat WhatsApp
        </a>

      </div>
    </section>
  `;
}
